<template>
  <v-card>
    <v-card-title
      class="pr-2"
      :style="{ backgroundColor: companyPrimaryColor }"
    >
      <h2 style="color:white">Gebruiker toevoegen</h2>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeAddUserDialog()">
        <v-icon dark color="white">close</v-icon>
      </v-btn>
    </v-card-title>

    <v-alert class="pa-4 ma-0" v-if="feedback" :value="true" type="warning">{{
      feedback
    }}</v-alert>

    <v-divider></v-divider>

    <v-card-text>
      <v-form ref="AddUserForm" lazy-validation>
        <v-container grid-list-md fluid class="ma-0 pa-0">
          <v-layout row wrap class="ma-0 pa-0">
            <v-flex xs12 v-if="formType == 'superadmin'">
              <v-select
                class="pt-2"
                :items="companies"
                v-model="signup.company"
                label="Bedrijf"
                hint="Selecteer bij welk bedrijf de gebruiker hoort"
                item-text="name"
                item-value="id"
                prepend-inner-icon="business"
                persistent-hint
                v-on:input="loadBranches()"
                :color="companyPrimaryColor"
                :item-color="companyPrimaryColor"
                background-color="background"
                hide-details
                outlined
              ></v-select>
            </v-flex>
            <v-flex md6 xs12>
              <v-text-field
                class="pt-2"
                label="Voornaam"
                v-model="signup.firstName"
                autocomplete="disabled"
                prepend-inner-icon="account_box"
                :color="companyPrimaryColor"
                background-color="background"
                hide-details
                outlined
                required
              ></v-text-field>
            </v-flex>
            <v-flex md6 xs12>
              <v-text-field
                class="pt-2"
                label="Achternaam"
                v-model="signup.lastName"
                autocomplete="disabled"
                prepend-inner-icon="account_box"
                :color="companyPrimaryColor"
                background-color="background"
                hide-details
                outlined
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                class="pt-2"
                label="E-mailadres"
                v-model="signup.email"
                :rules="emailRules"
                autocomplete="disabled"
                :color="companyPrimaryColor"
                background-color="background"
                hide-details
                outlined
                required
                prepend-inner-icon="email"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-select
                class="pt-2"
                :items="userRoles"
                v-model="signup.userRole"
                label="Rol"
                item-text="name"
                item-value="id"
                prepend-inner-icon="verified_user"
                :color="companyPrimaryColor"
                :item-color="companyPrimaryColor"
                background-color="background"
                hide-details
                outlined
                required
              ></v-select>
              <div
                v-if="signup.userRole == 'admin'"
                class="userrole-explaination"
              >
                Een
                <b>Admin</b> heeft alle bevoegdheden.
              </div>
              <div
                v-if="signup.userRole == 'manager'"
                class="userrole-explaination"
              >
                Een
                <b>Managers</b> heeft de bevoegdheid om gegevens van medewerkers
                te wijzigen en nieuwe gebruikers aan te maken. Extra
                gebruikerrechten kunnen per gebruiker worden toegevoegd.
              </div>
              <div
                v-if="signup.userRole == 'employee'"
                class="userrole-explaination"
              >
                Een
                <b>Medewerker</b> heeft standaard alleen de bevoegdheid om
                beperkte gegevens te bekijken. Extra gebruikerrechten kunnen per
                gebruiker worden toegevoegd.
              </div>
            </v-flex>

            <v-flex
              xs12
              v-if="
                signup.userRole == 'employee' || signup.userRole == 'manager'
              "
            >
              <v-select
                class="pt-2"
                v-if="formType == 'superadmin'"
                :items="loadedBranches"
                v-model="signup.branches"
                label="Vestigingen"
                item-text="branchName"
                hint="Selecteer tot welke branches de gebruiker toegang heeft"
                item-value="id"
                multiple
                prepend-inner-icon="business"
                persistent-hint
                :color="companyPrimaryColor"
                :item-color="companyPrimaryColor"
                background-color="background"
                hide-details
                outlined
                required
              ></v-select>
              <v-select
                class="pt-2"
                v-if="formType == 'company'"
                :items="branches"
                v-model="signup.branches"
                label="Vestigingen"
                item-text="branchName"
                hint="Selecteer tot welke branches de gebruiker toegang heeft"
                item-value="id"
                multiple
                prepend-inner-icon="business"
                persistent-hint
                :color="companyPrimaryColor"
                :item-color="companyPrimaryColor"
                background-color="background"
                hide-details
                outlined
                required
              ></v-select>
            </v-flex>
            <v-flex xs12 v-if="formType == 'superadmin'">
              <v-switch
                :color="companyPrimaryColor"
                v-model="signup.callActive"
                label="Call Center actief voor gebruiker"
                class="pa-0"
                hide-details
              >
              </v-switch>
            </v-flex>

            <v-flex xs12 v-if="formType == 'superadmin' && signup.callActive">
              <v-switch
                :color="companyPrimaryColor"
                v-model="signup.hogansCaller"
                label="Belt voor Hogans Call Center"
                class="pa-0"
                hide-details
                v-on:change="setCallToType()"
              >
              </v-switch>
            </v-flex>

            <v-flex xs12 v-if="formType == 'superadmin' && signup.callActive">
              <v-select
                class="pt-2"
                :items="filteredCompanies"
                :item-color="companyPrimaryColor"
                background-color="background"
                item-text="name"
                item-value="id"
                multiple
                chips
                prepend-inner-icon="check"
                v-model="signup.callCompanies"
                no-data-text="Geen bedrijven gevonden."
                label="Selecteer bedrijven voor Call Center"
                :hint="
                  `${signup.callCompanies.length}/${companies.length} bedrijven geselecteerd.`
                "
                persistent-hint
                outlined
              >
                <template v-slot:prepend-item>
                  <v-list-item>
                    <v-list-item-content class="pt-0">
                      <v-text-field
                        :color="companyPrimaryColor"
                        placeholder="Zoeken"
                        prepend-inner-icon="search"
                        v-model="searchCompanies"
                        hide-details
                        clearable
                        dense
                      ></v-text-field>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <div
                    v-if="searchCompanies && searchCompanies.length > 0"
                    style="padding: 4px 17px 3px 17px; background-color:rgba(0,0,0, 0.02); color: rgba(0, 0, 0, 0.6); text-align: center; font-size: 12px"
                  >
                    {{ filteredCompanies.length }} van
                    {{ companies.length }} bedrijven
                  </div>
                  <v-divider v-if="searchCompanies.length > 0"></v-divider>
                </template>
                <template v-slot:selection="{ item, index }">
                  <v-chip small color="primary" dark v-if="index === 0"
                    ><span style="color:white">{{ item.name }}</span></v-chip
                  >
                  <v-chip small color="primary" dark v-if="index === 1"
                    ><span style="color:white">{{ item.name }}</span></v-chip
                  >
                  <v-chip small color="primary" dark v-if="index === 2"
                    ><span style="color:white">{{ item.name }}</span></v-chip
                  >
                  <v-chip small color="primary" dark v-if="index === 3"
                    ><span style="color:white">{{ item.name }}</span></v-chip
                  >
                  <v-chip small color="primary" dark v-if="index === 4"
                    ><span style="color:white">{{ item.name }}</span></v-chip
                  >
                  <v-chip small color="primary" dark v-if="index === 5"
                    ><span style="color:white">{{ item.name }}</span></v-chip
                  >
                  <span v-if="index === 6" class="grey--text caption"
                    >(+{{ signup.callCompanies.length - 6 }} andere)</span
                  >
                </template>
              </v-select>
            </v-flex>

            <v-flex
              xs12
              v-if="
                formType == 'superadmin' &&
                  signup.callActive &&
                  !signup.hogansCaller
              "
            >
              <v-text-field
                class="pt-2"
                label="Telefoonnummer Call Center"
                v-model="signup.callTo"
                autocomplete="disabled"
                :color="companyPrimaryColor"
                background-color="background"
                hide-details
                outlined
                required
                prepend-inner-icon="phone"
              ></v-text-field>
            </v-flex>

            <v-flex
              xs12
              v-if="
                formType == 'superadmin' &&
                  signup.callActive &&
                  signup.hogansCaller
              "
            >
              <v-card
                outlined
                :color="$vuetify.theme.themes[theme].menuhover"
                class="pa-4"
              >
                <h3>Telefoonnummers voor Call Center</h3>
                <div v-if="signup.callCompanies.length > 0">
                  <div
                    v-for="(company, index) in signup.callCompanies"
                    :key="index"
                  >
                    <v-text-field
                      class="mt-4"
                      :label="`Telefoonnummer voor ${company}`"
                      v-model="signup.callTo[company]"
                      autocomplete="disabled"
                      :color="companyPrimaryColor"
                      :background-color="$vuetify.theme.themes[theme].menu"
                      hide-details
                      outlined
                      required
                      prepend-inner-icon="phone"
                    ></v-text-field>
                  </div>
                </div>
                <div class="pt-1" v-else>
                  <i>Selecteer bedrijven voor Call Center</i>
                </div>
              </v-card>
            </v-flex>

            <v-flex
              xs12
              v-if="formType == 'superadmin' && signup.userRole == 'superadmin'"
            >
              <v-select
                class="pt-2"
                :items="filteredCompanies"
                :item-color="companyPrimaryColor"
                background-color="background"
                item-text="name"
                item-value="id"
                multiple
                chips
                prepend-inner-icon="check"
                v-model="signup.accessCompanies"
                no-data-text="Geen bedrijven gevonden."
                label="Selecteer toegang tot bedrijven"
                :hint="
                  `${signup.accessCompanies.length}/${companies.length} bedrijven geselecteerd.`
                "
                persistent-hint
                outlined
              >
                <template v-slot:prepend-item>
                  <v-list-item>
                    <v-list-item-content class="pt-0">
                      <v-text-field
                        :color="companyPrimaryColor"
                        placeholder="Zoeken"
                        prepend-inner-icon="search"
                        v-model="searchCompanies"
                        hide-details
                        clearable
                        dense
                      ></v-text-field>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <div
                    v-if="searchCompanies && searchCompanies.length > 0"
                    style="padding: 4px 17px 3px 17px; background-color:rgba(0,0,0, 0.02); color: rgba(0, 0, 0, 0.6); text-align: center; font-size: 12px"
                  >
                    {{ filteredCompanies.length }} van
                    {{ companies.length }} bedrijven
                  </div>
                  <v-divider v-if="searchCompanies.length > 0"></v-divider>
                </template>
                <template v-slot:selection="{ item, index }">
                  <v-chip small color="primary" dark v-if="index === 0"
                    ><span style="color:white">{{ item.name }}</span></v-chip
                  >
                  <v-chip small color="primary" dark v-if="index === 1"
                    ><span style="color:white">{{ item.name }}</span></v-chip
                  >
                  <v-chip small color="primary" dark v-if="index === 2"
                    ><span style="color:white">{{ item.name }}</span></v-chip
                  >
                  <v-chip small color="primary" dark v-if="index === 3"
                    ><span style="color:white">{{ item.name }}</span></v-chip
                  >
                  <v-chip small color="primary" dark v-if="index === 4"
                    ><span style="color:white">{{ item.name }}</span></v-chip
                  >
                  <v-chip small color="primary" dark v-if="index === 5"
                    ><span style="color:white">{{ item.name }}</span></v-chip
                  >
                  <span v-if="index === 6" class="grey--text caption"
                    >(+{{ signup.accessCompanies.length - 6 }} andere)</span
                  >
                </template>
              </v-select>
            </v-flex>
            <v-flex
              xs12
              class="user-permissions-wrapper clear"
              v-if="
                (signup.userRole == 'employee' &&
                  (userRole == 'admin' || userRole == 'superadmin')) ||
                  (signup.userRole == 'manager' &&
                    (userRole == 'admin' || userRole == 'superadmin'))
              "
            >
              <div
                v-if="companyJourney || companyNarrowcasting"
                style="padding: 10px 0"
                class="clear"
              >
                <div class="user-permissions-icon">
                  <v-icon>accessibility</v-icon>
                </div>
                <h3 style="padding: 7px 0 0 5px;">
                  Selecteer extra gebruikersrechten
                </h3>
              </div>
              <div class="user-permissions">
                <!-- Gebruikersrechten Customer Journey-->
                <div
                  v-if="companyJourney == true"
                  class="permissions-customerjourney"
                >
                  <h4>Reviews</h4>
                  <v-checkbox
                    label="Reviews bekijken"
                    v-model="signup.userPermissions.showJourneyData"
                    :color="companyPrimaryColor"
                  ></v-checkbox>
                  <v-checkbox
                    v-if="signup.userPermissions.showJourneyData"
                    label="Vragenlijsten en vragen bekijken"
                    v-model="signup.userPermissions.journeyViewJourney"
                    :color="companyPrimaryColor"
                  ></v-checkbox>
                  <v-checkbox
                    v-if="signup.userPermissions.showJourneyData"
                    label="Stages en vragen maken/bewerken"
                    v-model="signup.userPermissions.journeyEditQuestions"
                    :color="companyPrimaryColor"
                  ></v-checkbox>
                  <v-checkbox
                    v-if="signup.userPermissions.showJourneyData"
                    label="Vragenlijsten maken/bewerken"
                    v-model="signup.userPermissions.journeyEditJourney"
                    :color="companyPrimaryColor"
                  ></v-checkbox>
                </div>
                <!-- Gebruikersrechten Relevantcasting-->
                <div
                  v-if="companyNarrowcasting == true"
                  class="permissions-relevantcasting"
                >
                  <h4>Relevantcasting</h4>
                  <v-checkbox
                    label="Content uploaden"
                    v-model="signup.userPermissions.castingUploadContent"
                    :color="companyPrimaryColor"
                  ></v-checkbox>
                  <v-checkbox
                    label="Afspeellijst bewerken"
                    v-model="signup.userPermissions.castingEditPlaylist"
                    :color="companyPrimaryColor"
                  ></v-checkbox>
                </div>

                <!-- Gebruikersrechten Dossier -->
                <div
                  v-if="companyDossier == true"
                  class="permissions-relevantcasting"
                >
                  <h4>Dossier</h4>
                  <v-checkbox
                    label="Klantreviews verbergen in dossier"
                    v-model="signup.userPermissions.hideCustomerReviews"
                    :color="companyPrimaryColor"
                  ></v-checkbox>
                  <v-checkbox
                    label="Extra klantinformatie verbergen in dossier"
                    v-model="signup.userPermissions.hideCustomerInfo"
                    :color="companyPrimaryColor"
                  ></v-checkbox>
                </div>
              </div>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                label="Wachtwoord"
                v-model="signup.password"
                :rules="passwordRules"
                prepend-inner-icon="lock"
                hint="Minimaal 6 characters"
                min="6"
                counter
                autocomplete="disabled"
                :color="companyPrimaryColor"
                background-color="background"
                hide-details
                outlined
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-switch
                v-if="formType == 'superadmin'"
                :color="companyPrimaryColor"
                v-model="signup.sendEmail"
                class="pa-0"
                hide-details
              >
                <template slot="label">
                  <span
                    :style="{ color: $vuetify.theme.themes[theme].text }"
                    style="margin-right: 5px;"
                    >E-mail gegevens naar nieuwe gebruiker</span
                  >
                  <v-tooltip class="ma-0 pa-0" right>
                    <template v-slot:activator="{ on }">
                      <v-icon small :color="companyPrimaryColor" v-on="on"
                        >help</v-icon
                      >
                    </template>
                    <span class="text--white"
                      >De nieuwe gebruiker ontvangt een e-mail met
                      inloggegevens.</span
                    >
                  </v-tooltip>
                </template>
              </v-switch>
              <v-alert v-else :value="true" type="info">
                De nieuwe gebruiker ontvangt een e-mail met inloggegevens.
              </v-alert>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-container grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex
            xs12
            md6
            class="text-left"
            v-if="
              $vuetify.breakpoint.name != 'sm' &&
                $vuetify.breakpoint.name != 'xs'
            "
          >
            <v-btn
              outlined
              depressed
              color="#8B93A6"
              @click="closeAddUserDialog()"
            >
              Annuleren
            </v-btn>
          </v-flex>
          <v-flex xs12 md6 class="text-right">
            <v-btn
              dark
              rounded
              :block="
                $vuetify.breakpoint.name == 'sm' ||
                  $vuetify.breakpoint.name == 'xs'
              "
              :color="companySecondaryColor"
              @click="signUp()"
            >
              Gebruiker toevoegen
              <v-icon right dark>chevron_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
import slugify from "slugify";
import axios from "axios";
import db from "../../firebase/init";
import firebase from "firebase/compat/app";
import platform from "platform";

export default {
  name: "add-user-form",
  props: {
    formType: String,
    showDialog: Boolean,
    companies: Array,
    branches: Array,
    activeCompData: Object,
  },
  data() {
    return {
      signup: {
        userRole: "admin",
        userPermissions: {},
        accessCompanies: [],
        callCompanies: [],
        callActive: false,
        hogansCaller: false,
        company: null,
        branches: [],
        callTo: {},
        sendEmail: true,
        operator: false,
      },
      feedback: null,
      errors: [],
      searchCompanies: "",
      loadedBranches: [],
      recordId: "",
      emailRules: [
        (v) => !!v || "E-mail is verplicht",
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail is niet geldig",
      ],
      passwordRules: [(v) => !!v || "Wachtwoord is verplicht"],
    };
  },

  methods: {
    closeAddUserDialog() {
      this.$emit("newUserDialogChange", false);
    },

    setCallToType() {
      if (this.signup.hogansCaller) {
        this.signup.callTo = {};
      } else {
        this.signup.callTo = "";
      }
    },

    signUp() {
      if (
        this.signup.email &&
        this.signup.password &&
        this.signup.firstName &&
        this.signup.lastName &&
        this.signup.userRole
      ) {
        // Set userdata if user is added by a company
        let accessCompanies = [];
        let userCompany = null;
        if (!this.signup.company) {
          userCompany = this.activeCompData.id;
        } else {
          userCompany = this.signup.company;
        }

        if (this.signup.accessCompanies.length == 0) {
          accessCompanies.push(userCompany);
        } else {
          accessCompanies = this.signup.accessCompanies;
        }

        this.recordId = slugify(this.signup.email, {
          replacement: "",
          remove: /[!@#$%^&*()"';:.,]/g,
          lower: true,
        });
        this.feedback = null;
        let ref = db.collection("users").doc(this.recordId);
        ref.get().then((doc) => {
          if (doc.exists) {
            this.feedback = "Er bestaat al een  gebruiker met dit emailadres";
          } else {
            var config = {
              method: "post",
              url:
                "https://europe-west1-dev-app-137723.cloudfunctions.net/auth",
              headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
              },
              data: {
                type: "createUser",
                email: this.signup.email,
                password: this.signup.password,
                status: true,
              },
            };

            axios(config)
              .then((response) => {
                ref.set({
                  firstName: this.signup.firstName,
                  lastName: this.signup.lastName,
                  userRole: this.signup.userRole,
                  email: this.signup.email,
                  user_id: response.data,
                  branches: this.signup.branches,
                  userPermissions: this.signup.userPermissions,
                  accessCompanies: accessCompanies,
                  company: userCompany,
                  callCompanies: this.signup.callCompanies,
                  callActive: this.signup.callActive,
                  hogansCaller: this.signup.hogansCaller,
                  operator: this.signup.operator,
                  callTo: this.signup.callTo,
                  active: true,
                });
              })
              // .catch(error=>{
              //   console.error("Error bij aanmaken user: ", error)
              // })

              .then(() => {
                // Log Action
                db.collection("log").add({
                  time: new Date(),
                  logType: "info",
                  user: this.userFirstName + " " + this.userLastName,
                  userType: this.userRole,
                  company: this.userCompany,
                  actionType: "User Action",
                  action: "Nieuwe gebruiker aangemaakt",
                  software: String(platform.os),
                  browser: platform.name + " " + platform.version,
                  pillarrrVersion: this.$store.state.version,
                  extra:
                    "<b>Naam</b>: " +
                    this.signup.firstName +
                    " " +
                    this.signup.lastName +
                    "<br>" +
                    "<b>Rol</b>: " +
                    this.signup.userRole +
                    "<br>" +
                    "<b>Email</b>: " +
                    this.signup.email +
                    "<br>" +
                    "<b>Bedrijf</b>: " +
                    this.signup.company +
                    "<br>" +
                    "<b>Toegang</b>: " +
                    this.signup.accessCompanies,
                });
              })
              .then(() => {
                let emailHtml =
                  "<body style='width:100% !important; margin:0 !important; -webkit-text-size-adjust:none; -ms-text-size-adjust:none; background-color:#F6F7FB; padding: 40px 0!important;'><table cellpadding='0' cellspacing='0' border='0' id='backgroundTable' style='height:auto !important; margin:0 auto; padding:0; max-width: 600px; width:100% !important; background-color:#FFFFFF; border-radius: 5px; color: #2A0C44; overflow: hidden;border: 1px solid #E8E9EE; box-shadow: 0 1px 4px 0 rgba(0,0,0,0.04);'><tr><td><div id='tablewrap' style='width:100% !important; max-width:600px !important; text-align:center !important; margin-top:0 !important; margin-right: auto !important; margin-bottom:0 !important; margin-left: auto !important; padding: 40px 0!important;'><table id='contenttable' width='550' align='center' cellpadding='0' cellspacing='0' border='0' style='background-color:#FFFFFF; text-align:center !important; margin-top:0 !important; margin-right: auto !important; margin-bottom:0 !important; margin-left: auto !important; border:none; width: 100% !important; max-width:550px !important;'><tr><td width='100%'><a href='https://pillarrr.io/'><img style='width: 100%; height: auto; display: block ;margin: 0 auto; width: 100px; height: auto;' src='https://pillarrr.io/wp-content/uploads/2019/05/Pillar-Logo-Mail.png'/></a></a></td></tr><tr><td style='width: 100%; padding: 30px 0;'><p style='font-family: Helvetica, Arial, sans-serif; font-size: 16px; line-height: 26px; padding: 20px 10px 0px 10px; text-align: center; color: #2A0C44; margin:0;'>Beste " +
                  this.signup.firstName +
                  ",<br><br>Gebruik de onderstaande gegevens om in te loggen op jouw persoonlijke Pillarrr account.<br><br><strong>E-mailadres: </strong> <span style='color: #2A0C44!important;'>" +
                  this.signup.email +
                  "</span><br><strong>  Wachtwoord:</strong> " +
                  this.signup.password +
                  "</p></td></tr><tr><td><a href='https://app.pillarrr.io/' style='font-family: Helvetica, Arial, sans-serif; font-size: 18px; background-color: #53118e; border-radius: 100px; cursor: pointer; font-weight: 600; color: #fff; text-decoration: none; line-height: 22px; display: block; max-width: 150px; padding: 10px 20px; margin: 10px auto;' >Inloggen</a></td></tr><tr><td style='width: 100%; padding: 10px 0;'><a href='https://pillarrr.io/' style='font-family: Helvetica, Arial, sans-serif; font-size: 14px; line-height: 24px; padding: 20px 10px 0px 10px; text-align: center; color: #2A0C44!important;  margin:0;'>Meer informatie over Pillarrr</a></td></tr></table></div></td></tr></table><table cellpadding='0' cellspacing='0' border='0' style='font-family: Helvetica, Arial, sans-serif; font-size: 11px; line-height: 14px; height:auto !important; margin:0 auto; padding: 20px ; max-width: 600px; width:100% !important;  color: rgba(37,20,51,0.33); overflow: hidden; text-align: center;'><tr><td>If this message apparently was mistakenly sent to you, please return it immediately to the sender, delete the original and not retain copies. This email goes out Hogans and / or affiliated companies and is intended for the addressee only.  If you are not designated recipient, you should refrain from disclosure, use, disclosure, copying or further distribution of the content of this announcement and / or any attachments.<br><br>© Hogans | All Rights Reserved</td></tr></table></body>";

                if (this.signup.sendEmail == true) {
                  db.collection("mail").add({
                    to: this.signup.email,
                    message: {
                      subject: "Inloggegevens voor jouw Pillarrr account",
                      html: emailHtml,
                    },
                  });
                }
              })
              .then(() => {
                this.$emit("updateData");
                console.log("User Registration Succesfull");
                this.closeAddUserDialog();
                this.$refs.AddUserForm.reset();
              })
              .catch((error) => {
                console.error("User Registration Unsuccesfull: " + error);
                this.feedback = error.message;
                db.collection("log").add({
                  time: new Date(),
                  logType: "error",
                  user: this.userFirstName + " " + this.userLastName,
                  userType: this.userRole,
                  company: this.userCompany,
                  software: String(platform.os),
                  browser: platform.name + " " + platform.version,
                  pillarrrVersion: this.$store.state.version,
                  actionType: "User Action",
                  action:
                    "User Registration Unsuccesfull: " + this.activeCompName,
                  extra: JSON.stringify(error),
                });
              });
          }
        });
      } else {
        this.feedback = "Vul alle velden in";
      }
    },

    loadBranches() {
      db.collection("branches")
        .where("compId", "==", this.signup.company)
        .get()
        .then((snap) => {
          this.loadedBranches = [];
          snap.forEach((doc) => {
            let branchCollection = doc.data();
            branchCollection.id = doc.id;
            this.loadedBranches.push(branchCollection);
          });
        })
        .catch((error) => {
          console.error("Error loading branches: " + error);
        });
    },
  },
  computed: {
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    userRoles() {
      let userRolesSuperadmin = [
        { name: "Superadmin", id: "superadmin" },
        { name: "Admin", id: "admin" },
        // { name: "Manager", id: "manager"},
        // { name: "Medewerker", id: "employee"}
      ];
      let userRoles = [
        { name: "Admin", id: "admin" },
        { name: "Manager", id: "manager" },
        { name: "Medewerker", id: "employee" },
      ];
      if (this.formType == "superadmin") {
        return userRolesSuperadmin;
      } else {
        return userRoles;
      }
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    companyNarrowcasting() {
      if (_.includes(this.companyPackages, "narrowcasting")) {
        return true;
      } else {
        return false;
      }
    },
    companyDossier() {
      if (_.includes(this.companyPackages, "dossier")) {
        return true;
      } else {
        return false;
      }
    },
    companyPackages() {
      if (this.userRole == "superadmin") {
        if (this.activeCompData && this.activeCompData.packages) {
          return this.activeCompData.packages;
        } else {
          return new Array();
        }
      } else {
        return this.$store.state.companyPackages;
      }
    },
    companyType() {
      return this.$store.state.companyType;
    },
    companyJourney() {
      if (_.includes(this.companyPackages, "customerjourney")) {
        return true;
      } else {
        return false;
      }
    },
    filteredCompanies() {
      if (this.searchCompanies && this.searchCompanies.length > 0) {
        return this.companies.filter((company) => {
          return company.name
            .toLowerCase()
            .includes(this.searchCompanies.toLowerCase());
        });
      } else {
        return this.companies;
      }
    },
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
    companyBarometers() {
      if (_.includes(this.companyPackages, "barometers")) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
<style>
.userrole-explaination {
  font-family: "Sofia Pro", sans-serif;
  color: var(--v-text-base);
  font-weight: 400;
  padding: 0 0 5px 0;
  font-size: 12px;
  margin: 0;
}

.user-permissions-wrapper {
  padding: 20px 0 0 0;
}
.user-permissions-icon {
  float: left;
  width: 23px;
  margin: 5px 10px 0 0;
}

.user-permissions {
  float: left;
}

p.custom-formfield-label {
  font-family: "Sofia Pro", sans-serif;
  color: var(--v-text-base);
  font-weight: 400;
  padding: 0 0 5px 0;
  font-size: 12px;
  margin: 0;
}

p.permission-label {
  font-family: "Sofia Pro", sans-serif;
  font-weight: 400;
  padding: 0 0 5px 0;
  font-size: 16px;
  margin: 0;
}

.user-permissions .v-input--checkbox {
  margin: 0;
  padding: 0;
}

.user-permissions .v-input--checkbox .v-input__slot {
  margin: 0;
  padding: 0;
}

.user-permissions .v-input--checkbox .v-input__slot label {
  padding: 3px 0 0 0;
  font-size: 14px;
}
</style>
